import { FirePracticalAssessmentService } from 'src/app/services/fire-practical-assessment-services/fire-practical-assessment.service';
import { Component, OnInit, ViewChild, OnDestroy, NgZone } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { filter, first, map } from 'rxjs/operators';
import { FireAssessmentService } from '../../services/fire-assessment.service'; // CRUD API service class
import { ToastrService } from 'ngx-toastr'; // Alert message using NGX toastr
import { Business } from '../../models/business';
import { Subscription } from 'rxjs';
import { AngularFireDatabase } from '@angular/fire/database';
import { AuthService } from 'src/app/shared/service/auth.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { FireActionItemService } from 'src/app/services/fire-action-items/fire-action-item.service';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
import { Observable } from 'rxjs';
import { generateCode } from 'src/app/consts/conts.global';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from '../confirmation-box/confirmation-box.component';
import { Router } from '@angular/router';
import { FireBusinessAssessmentService } from 'src/app/services/fire-business-assessment-services/fire-business-assessment.service';

@Component({
  selector: 'app-entrep-dash',
  templateUrl: './entrep-dash.component.html',
  styleUrls: ['./entrep-dash.component.scss'],
})
export class EntrepDashComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  userData = this.authService.userData;
  emailInput: string;
  isShown: boolean;
  isShown2: boolean;
  user: any;
  isAdmin = false;
  adminCode: string;
  isEntreprenerEdit = false;
  isUserCodeAssociatedWithAssessment$: Observable<boolean>;

  constructor(
    public fireAssessment: FireAssessmentService,
    public firePracticalAssessment: FirePracticalAssessmentService,
    public fireBusinessAssessment: FireBusinessAssessmentService,
    public toastr: ToastrService,
    private db: AngularFireDatabase,
    private firestoredb: AngularFirestore,
    private authService: AuthService,
    public fireActionItem: FireActionItemService,
    private guard: AuthGuard,
    private db2: AngularFirestore,
    public router: Router,
    public ngZone: NgZone,
    private realdb: AngularFireDatabase,
    private dialog: MatDialog
  ) {}
  p = 1; // Setup up pagination variable

  Assessment: Business[]; // Save assessment data in Assessment's array.
  hideWhenNoAssessment = false; // Hide assessment data table when no assessment.
  noData = false; // Showing No Assessment Message, when no assessment in database.
  hideWhenNoOperatingAssessment = false;
  hideWhenNoBusinessAssessment = false;
  itemKeys = [];
  itemKeysOperating = [];
  itemKeysBusiness = [];
  data = [];
  dataOperating = [];
  dataBusiness = [];
  assessmentKey!: any;
  readAssessmenListSub: Subscription;
  overallScore = 87;
  revCalc = 9050;
  numAssessment = 0;
  step = 0;
  assessmentPayload: any;
  actionItemID!: any;
  actionItemData: any;

  @ViewChild('new-assessment') assessmentButton: HTMLButtonElement;

  // K-Andre function to get itemKey and data for view.
  getItemKeys() {
    const assessmentList = this.fireAssessment.readAssessmentsList();
    this.db
      .list('users')
      .valueChanges()
      .pipe(
        first(),
        filter((value) => !!value?.length && this.authService.isAdmin)
      )
      .pipe(
        map((payload: any) => {
          const allUsersBusiness = payload
            .map((value: any) => Object.entries(value))
            .flat()
            .map((value: any) => {
              return { key: value[0], ...value[1] };
            });
          const userBusinessInfo =
            allUsersBusiness?.length &&
            allUsersBusiness.filter(
              (val: any) =>
                !!val.adminCode &&
                !val.adminCode?.disabled &&
                !!this.authService.adminCode &&
                (val.adminCode === this.authService.adminCode ||
                  val.adminCode?.value === this.authService.adminCode?.value)
            );
          return userBusinessInfo;
        }),
        filter((value) => !!value?.length)
      )
      .subscribe((usersInfo) => {
        const newData = [...this.data, ...usersInfo];
        this.data = [
          ...newData
            .reduce((map, obj) => map.set(obj?.key, obj), new Map())
            .values(),
        ];
      });

    assessmentList
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => ({
            key: a.payload.doc.id,
            ...a.payload.doc.data(),
          }))
        )
      )
      .subscribe((data) => {
        this.itemKeys = data.map((item) => item.key);
        this.data = data;
        this.numAssessment = this.data.length;
        return this.itemKeys;
      });
  }

  getItemKeysOperating() {
    const assessmentListOperating = this.firePracticalAssessment.readAssessmentsListOperating();
    this.db
      .list('users')
      .valueChanges()
      .pipe(
        first(),
        filter((value) => !!value?.length && this.authService.isAdmin)
      )
      .pipe(
        map((payload: any) => {
          const allUsersBusinessOperating = payload
            .map((value: any) => Object.entries(value))
            .flat()
            .map((value: any) => {
              return { key: value[0], ...value[1] };
            });
          const userBusinessInfoOperating =
            allUsersBusinessOperating?.length &&
            allUsersBusinessOperating.filter(
              (val) =>
                !!val.adminCode &&
                !!this.authService.adminCode &&
                val.adminCode === this.authService.adminCode
            );
          return userBusinessInfoOperating;
        }),
        filter((value) => !!value?.length)
      )
      .subscribe((usersInfo) => {
        const newData = [...this.dataOperating, ...usersInfo];
        this.dataOperating = [
          ...newData
            .reduce((map, obj) => map.set(obj?.key, obj), new Map())
            .values(),
        ];
      });

    assessmentListOperating
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => ({
            key: a.payload.doc.id,
            ...a.payload.doc.data(),
          }))
        )
      )
      .subscribe((dataOperating) => {
        this.itemKeysOperating = dataOperating.map((item) => item.key);
        this.dataOperating = dataOperating;
        this.numAssessment = this.dataOperating.length;
        return this.itemKeysOperating;
      });
  }

  getItemKeysBusiness() {
    const assessmentListBusiness = this.fireBusinessAssessment.readAssessmentsList();
    this.db
      .list('users')
      .valueChanges()
      .pipe(
        first(),
        filter((value) => !!value?.length && this.authService.isAdmin)
      )
      .pipe(
        map((payload: any) => {
          const allUsersBusinessAssessment = payload
            .map((value: any) => Object.entries(value))
            .flat()
            .map((value: any) => {
              return { key: value[0], ...value[1] };
            });
          const userBusinessInfoBusiness =
          allUsersBusinessAssessment?.length &&
          allUsersBusinessAssessment.filter(
              (val) =>
                !!val.adminCode &&
                !!this.authService.adminCode &&
                val.adminCode === this.authService.adminCode
            );
          return userBusinessInfoBusiness;
        }),
        filter((value) => !!value?.length)
      )
      .subscribe((usersInfo) => {
        const newData = [...this.dataBusiness, ...usersInfo];
        this.dataBusiness = [
          ...newData
            .reduce((map, obj) => map.set(obj?.key, obj), new Map())
            .values(),
        ];
      });

    assessmentListBusiness
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => ({
            key: a.payload.doc.id,
            ...a.payload.doc.data(),
          }))
        )
      )
      .subscribe((dataBusiness) => {
        this.itemKeysBusiness = dataBusiness.map((item) => item.key);
        this.dataBusiness = dataBusiness;
        this.numAssessment = this.dataBusiness.length;
        return this.itemKeysBusiness;
      });
  }

  freemiumUser() {
    this.fireAssessment
      .readAssessmentsList()
      .valueChanges()
      .subscribe((data) => {
        console.log('Here is the length' + data.length);
        if (data.length >= 1) {
          (<HTMLInputElement>(
            document.getElementById('new-assessment')
          )).style.display = 'none';
        } else {
          (<HTMLInputElement>(
            document.getElementById('new-assessment')
          )).style.display = 'block';
        }
      });
    // if (assessmentList.query.) { #check if assessmentList is > 1
    //   disable addAssessment button
    // }
  }
  // tslint:disable-next-line:typedef
  ngOnInit() {
    this.getItemKeys();
    this.getItemKeysOperating();
    this.getItemKeysBusiness();
    // this.freemiumUser()// Initialize assessments list when component is ready
    this.db2
      .collection('users')
      .doc(this.authService.userData.uid)
      .get()
      .toPromise()
      .then((payload: any) => {
        this.adminCode = payload?.data()?.adminCode;
        this.authService.adminCode = payload?.data()?.adminCode;
      });
    this.isAdmin =
      this.authService?.userData?.displayName?.includes('Admin') ||
      this.authService.userData?.typeOfUser === 'Admin';

    if (this.isAdmin) {
      this.isShown = true;
      this.isShown2 = false;
    } else {
      this.isShown = false;
      this.isShown2 = true;
    }
  }

  onSubmit2(value: string) {
    this.isEntreprenerEdit = !value.trim();
    if (!value || this.adminCode === value) {
      return;
    }
    this.adminCode = value.trim();
    !!value &&
      this.db2
        .collection('users')
        .doc(this.authService.userData.uid)
        .update({ adminCode: this.adminCode });
    this.authService.adminCode = this.adminCode;
  }

  remove(): void {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        title: 'Delete',
        content: `This action can not be undone and you <strong>will be unlinked</strong> to any assessments associated with this code. <br/>Your clients' assessments <strong>will be removed</strong> from your assessments list.`,
        action: 'Delete',
      },
    });
    dialogRef
      .afterClosed()
      .pipe(filter((response) => response === 'Delete'))
      .subscribe(() => {
        this.db2
          .collection('users')
          .doc(this.authService.userData.uid)
          .update({ adminCode: null })
          .then(() => {
            this.adminCode = null;
            this.authService.adminCode = null;
          });
      });
  }
  submitCode(isDisabled = false): void {
    if (isDisabled) {
      return;
    }
    const code = generateCode(30);
    this.adminCode = code;
    this.db2
      .collection('users')
      .doc(this.authService.userData.uid)
      .update({ adminCode: this.adminCode });
    this.authService.adminCode = this.adminCode;
  }

  checkTypeOfUser() {
    if (this.userData.displayName.includes('Entrepreneur')) {
      console.log('yo');
    } else {
      console.log('yoooo');
    }
  }
  assessmentInput: any;

  ngOnDestroy() {
    if (this.readAssessmenListSub) {
      this.readAssessmenListSub.unsubscribe();
    }
  }
  //Please see how to get this to work
  deleteAssessment(assessment) {
    if (window.confirm('Are you sure you want to delete this assessment?')) {
      // Asking from user before Deleting assessment data.
      this.fireAssessment.DeleteAssessment(); // Using Delete student API to delete assessment.
      this.toastr.success(assessment.busiName + ' successfully deleted'); // Alert message will show up when student successfully deleted.
    }
  }

  /*
async getActionItem(){
  const userAcions = await this.firestoredb.collection('user-actionItem', ref => ref.where('userID', '==', this.guard.uid)).get().toPromise();
  userAcions.forEach((doc) => {
    this.actionItemID = doc.id;
    this.actionItemData = doc.data(); 
    console.log(this.actionItemID)
  })
}
*/

  /*
 actionItem(){
  this.actionItemID = this.fireActionItem.getActionItemInfo();
  return this.actionItemID;
}*/
}
